import React, { useState } from 'react'
import {
  AccordionItem,
  AccordionHeader,
  Chevron,
  AccordionBody,
  ToggleWrapper,
  ToggleThumb,
  SubmitBtn,
} from './styles'

export const Toggle = ({
  checked,
  onChange,
}: {
  checked: boolean
  onChange: (v: boolean) => void
}) => (
  <ToggleWrapper onClick={() => onChange(!checked)} active={checked}>
    <ToggleThumb active={checked} />
  </ToggleWrapper>
)

export const Section = ({
  title,
  children,
  defaultOpen = false,
}: {
  title: string
  children: React.ReactNode
  defaultOpen?: boolean
}) => {
  const [open, setOpen] = useState(defaultOpen)
  return (
    <AccordionItem>
      <AccordionHeader onClick={() => setOpen(o => !o)}>
        <span>{title}</span>
        <Chevron open={open}>▾</Chevron>
      </AccordionHeader>
      {open && <AccordionBody>{children}</AccordionBody>}
    </AccordionItem>
  )
}

export const SaveBtn = ({
  loading,
  saved,
}: {
  loading: boolean
  saved: boolean
}) => (
  <SubmitBtn type="submit" disabled={loading}>
    {loading ? 'Enregistrement…' : saved ? '✓ Enregistré' : 'Enregistrer'}
  </SubmitBtn>
)
